import React from 'react'
import GLoading from 'tennders-market/common/components/element/GLoading'

const TableLoading = ({ className = '' }) => (
  <div className={className + ' d-flex align-center justify-center pt-20 pb-20'}>
    <GLoading size={35} />
  </div>
)
export default TableLoading
